/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { qreq } from "../../shared/qrequest";
import BaseCom from "../BaseCom"
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export default class CM2PerDayChart extends BaseCom {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
  }

  componentDidMount() {
    qreq.get('/api/chart/cm2-per-day', j => {
      if (j.list) {
        var total = 0;
        j.list.forEach(i => {
          total += i.dv;
        });
        this.setState({ data: j.list, total: total });
      }
    });
  }

  render() {
    return <ResponsiveContainer width="100%" height={300}>
      <LineChart
        width={500}
        height={300}
        data={this.state.data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip content={a => a ? <div className="bg-light text-dark border border-dark p-3"><div>{a.payload && a.payload.length > 0 && a.payload[0].payload ? a.payload[0].payload.name : null}</div><div>{a.payload && a.payload.length > 0 ? a.payload[0].value : null} cm<sup>2</sup></div></div> : null} />
        <Legend payload={[{ value: <>Total: {this.state.total} cm<sup>2</sup></>, type: 'line', id: 'ID01', color: '#7cae35' }]} />
        <Line type="monotone" dataKey="dv" stroke="#7cae35" activeDot={{ r: 8 }} />
      </LineChart>
    </ResponsiveContainer>;
  }
}